import axios from "axios";
import buildUrl from 'build-url-ts';
import { PaginatedRecords } from "src/types/common";
import { IRecordItem, IUpdateAccess } from "src/types/settings/streamAccessManagement";
import { Stream, FetchStreamAnalyticsResponse } from "src/types/streams";

const BASE_URL = process.env.REACT_APP_API_URL;
const streamsApiUrl = `${BASE_URL}/api/2.0/streams/`;

export const streamAccessManagementApi = {

  fetchPrivateStreams: async (): Promise<Stream[]> => {
    const response = await axios.get(`${streamsApiUrl}owner`);
    return response.data;
  },

  fetchStreamAnalytics: async (streamId: string): Promise<FetchStreamAnalyticsResponse> => {
    const url = buildUrl(streamsApiUrl, { path: `${streamId}/analytics` });
    const response = await axios.get(url);
    return response.data;
  },

  fetchAccess: async (page: number, streamId: string, searchQuery: string): Promise<PaginatedRecords<IRecordItem>> => {
    const url = buildUrl(`${streamsApiUrl}${streamId}/access/${page}`, {
      queryParams: {
        query: searchQuery,
      },
    });
    const response = await axios.get(url);
    return response.data;
  },

  updateAccess: async (data: any): Promise<IUpdateAccess> => {
    const response = await axios.put(
      `${streamsApiUrl}${data.id}/access/`,
      data,
    );
    return response.data;
  },

};
